import { WizardCurrentStep, WizardStepTree } from '../../../wizard/interfaces/wizard-step';
import { Source, SourceType } from '../../../shared/interfaces/source';
import { Destination, DestinationType } from '../../../shared/interfaces/destination';
import {
  CreatePipelineStepGroups,
  CreatePipelineStepPaths
} from '../create-pipeline-state-machine/interfaces/create-pipeline-step-paths';

export function getCreatePipelineWizardStepsWithExtraProps({
  stepGroups,
  wizardCurrentStep,
  source,
  destination,
  sourceType,
  destinationType
}: {
  stepGroups: WizardStepTree | null;
  wizardCurrentStep: WizardCurrentStep | null;
  source: Source | null;
  destination: Destination | null;
  sourceType: SourceType | null;
  destinationType: DestinationType | null;
}): WizardStepTree | null {
  const currentStepPath = wizardCurrentStep?.path as CreatePipelineStepPaths;

  const entityTypeExtraProps = {
    title: 'Selection',
    className: 'text-default'
  };

  const getSourceExtraProps = () => ({
    logo: source?.sourceType.logo || sourceType?.logo,
    title: source?.name || sourceType?.displayName
  });

  const getDestinationExtraProps = () => ({
    logo: destination?.destinationType.logo || destinationType?.logo,
    title: destination?.name || destinationType?.displayName
  });

  const getExtraProps = (group: WizardStepTree) => {
    switch (currentStepPath) {
      case CreatePipelineStepPaths.SELECT_SOURCE_TYPE:
        if (group.id === CreatePipelineStepGroups.SOURCE_SELECTION) {
          return entityTypeExtraProps;
        }

        break;

      case CreatePipelineStepPaths.SOURCE_CONNECTION_SETTINGS:
      case CreatePipelineStepPaths.SELECT_DESTINATION_TYPE:
      case CreatePipelineStepPaths.DESTINATION_CONNECTION_SETTINGS:
      case CreatePipelineStepPaths.PIPELINE_SETTINGS:
      case CreatePipelineStepPaths.CONFIGURE_OBJECTS:
      case CreatePipelineStepPaths.REVIEW:
        if (group.id === CreatePipelineStepGroups.SOURCE_SELECTION) {
          return getSourceExtraProps();
        }

        if (group.id === CreatePipelineStepGroups.DESTINATION_SELECTION) {
          if (currentStepPath === CreatePipelineStepPaths.SELECT_DESTINATION_TYPE) {
            return entityTypeExtraProps;
          }

          return getDestinationExtraProps();
        }

        break;

      default:
        return null;
    }

    return null;
  };

  if (!stepGroups) {
    return null;
  }

  return {
    ...stepGroups,
    children: stepGroups.children?.map(group => {
      const extraProps = getExtraProps(group);
      return extraProps ? { ...group, extraProps } : group;
    })
  } as WizardStepTree;
}
